import React from 'react'
import './publication.css'
import pelcovervol27no34 from "./PELCoverVol27No34.jpg"

function Volume27no34() {
  return (
    <div className="p-2">
      <section className='content-header d-flex flex-column justify-content-start'>
       <strong><h3 className="p-2" >Vol. 27, Nos. 3&4, Sep/Dec 2026</h3></strong>
        <div><img src={pelcovervol27no34} alt=" PEL Cover Vol 27 No 3&4" className ="col-6 col-lg-4 col-md-4"/></div>
        <h5 className="p-2">CONTENTS</h5>
            <div className="p-2 contents">
             <a href= '/volume-27-no3&4/AmbiguityinReferenceCohesion-ConfidenceAihebholoriaandFridayAkporherhe.pdf'><p> Ambiguity in Reference Cohesion: A Systemic Functional Grammar 
Analysis of Nigerian Supreme Court Judgments - 
 <strong> Confidence Aihebholoria & Friday Akporherhe</strong> - 1 </p> </a> 
              </div>
              <div className="p-2">
            <a href= '/volume-27-no3&4/AStudyoftheAccuracyofArtificialIntelligence-Bashir,A.A.,F.Oamen&J.O.Madu.pdf'><p>A Study of the Accuracy of Artificial Intelligence in the English Translation 
of Some Nigerian Indigenous Language Expressions - 
 <strong> Amina Abubakar Bashir, Felicia Oamen & JaneMaura Ogechukwu Madu</strong> - 15 </p></a> 
              </div>
              <div className="p-2">
              <a href= '/volume-27-no3&4/LinguisticAppraisalofCulinaryDiscourse-Eze-PeterandNlemchukwu.pdf'><p> A Linguistic Appraisal of Culinary Discourse on the Instagram Page of Some 
Nigerian Food Influencers - 
 <strong> Perpetua Chinyere Eze-Peter & Chidinma Charity Nlemchukwu</strong> - 31 </p></a>
              </div>
              <div className="p-2">
              <a href= '/volume-27-no3&4/PostproverbialVariationsamongYouths-Fasasi,K.A.andO.M.Oluwo.pdf'> <p> Postproverbial Variations among Youths in Southwest Nigeria: Culture Shift, Value 
Shift or Linguistic Creativity? - 
 <strong> Khabyr A. Fasasi & Oluwakemi Modupe Oluwo</strong> - 52 </p></a>
              </div>
              <div className="p-2">
              <a href= '/volume-27-no3&4/(Im)politenessinConflictTalksandMediatisedIdentityConstruction-Maledo,R.O.andE.L.Divramredje.pdf'><p> (Im)politeness in Conflict Talks and Mediatised Identity Construction in Nigeria’s 
10th Senate - 
 <strong> Richard Oliseyenum Maledo & Efeturi Lawrence Divramredje</strong> - 65 </p></a>
              </div>
              <div className="p-2">
             <a href='/volume-27-no3&4/NarratingMaleChildhoodTrauma–Ojekanmi,C.O.andE.B.Omobowale.pdf'> <p> Narrating Male Childhood Trauma in Elnathan John’s Born on a Tuesday and Novuyo Tshuma’s House of Stone - 
 <strong> Christianah Oluwaseun Ojekanmi & Emmanuel Babatunde Omobowale</strong> - 83 </p> </a>
              </div>
            <div className="p-2">
             <a href='/volume-27-no3&4/PersonalisationasAffectivePolarisation-Olapade,O..pdf'> <p> Personalisation as Affective Polarisation in Nigerian Adversarial Political Discourse 
(2021–2023) - 
 <strong> Olaide Olapade</strong> - 100 </p> </a>
              </div>
            <div className="p-2">
             <a href='/volume-27-no3&4/BeyondWords-Olutayo,G.&T.T.Adeona.pdf'> <p> Beyond Words: Ethnic Linguistic Patterns as Identity Markers Among Nigerian 
University Students - 
 <strong> Grace Olutayo & Tolani Tolulope Adeona</strong> - 121 </p> </a>
              </div>
                <div className="p-2">
             <a href='/volume-27-no3&4/ContextualInterpretationandMetaphoricalMeanings-Sandow,A.A..pdf'> <p> Contextual Interpretation and Metaphorical Meanings in Kusaal Wellerisms - 
 <strong> Atibiri Aweaka Sandow</strong> - 135 </p> </a>
              </div>
                            <div className="p-2">
             <a href='/volume-27-no3&4/MorphologicalProcessesinNupeNumeralSystem-Adamu,I.M.,Y.J.Umaru&T.O.Ashikeni.pdf'> <p> Morphological Processes in Nupe Numeral System - 
 <strong> Idris Manarakis Adamu, Yakubu Jacob Umaru & Thomas Ogah Ashikeni</strong> - 160 </p> </a>
              </div>              
            <hr/>
    
        </section>
    </div>
  )
}

export default Volume27no34;